var _path, _path2, _path3, _path4, _line, _line2, _line3, _circle, _path5, _path6, _path7, _path8, _path9, _line4, _line5, _line6, _path0, _path1, _path10, _path11, _line7, _line8, _line9, _path12, _path13, _line0, _line1, _line10, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactNormalDeschisActionarePrinCheie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 83,
    viewBox: "0 0 76 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.60019,
    cy: 43.4,
    r: 7.4,
    stroke: "black",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4952 61L5.62714 51H12.7108L15.6622 61H1.4952Z",
    stroke: "black",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 44,
    x2: 27,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 44,
    x2: 21,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28L38.6028 48.7332",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactNormalDeschisActionarePrinCheie);
export default __webpack_public_path__ + "static/media/contact_normal_deschis_actionare_prin_cheie.7a50da2831a5735bc29d53e38ed2888d.svg";
export { ForwardRef as ReactComponent };